import './App.css';
import '/node_modules/bootstrap/dist/js/bootstrap.js'
import '/node_modules/bootstrap/dist/css/bootstrap.css'
import './LMS_CSS/LMS_Login.css'
import './LMS_CSS/LMS_Layout.css'
import './LMS_CSS/LMS_Dashboard.css'
import './LMS_CSS/LMS_Masters.css'
import './LMS_CSS/LMS_Course_Management.css'
import './LMS_CSS/LMS_Quiz_Management.css'
import './LMS_CSS/LMS_File_Library.css'
import './LMS_CSS/LMS_Reports.css'
import { useEffect, useRef, useState } from 'react';
import { Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import ProtectedRoutes from './ProtectedRoute';
import LOGIN from './LMS_View/LMS_LOGIN/Login';
import Dashboard from './LMS_View/LMS_DASHBOARD/Dashboard';
import Department from './LMS_View/LMS_MASTERS/Department';
import AddGroup from './LMS_View/LMS_MASTERS/AddGroup';
import GroupList from './LMS_View/LMS_MASTERS/GroupList';
import Venue from './LMS_View/LMS_MASTERS/Venue';
import Announcement from './LMS_View/LMS_MASTERS/Announcement';
import Poll from './LMS_View/LMS_MASTERS/Poll';
import UserList from './LMS_View/LMS_MASTERS/UserList';
import QuizMarks from './LMS_View/LMS_MASTERS/QuizMarks';
import AddCourse from './LMS_View/LMS_COURSE_MANAGEMENT/AddCourse';
import CourseList from './LMS_View/LMS_COURSE_MANAGEMENT/CourseList';
import AddTraining from './LMS_View/LMS_COURSE_MANAGEMENT/AddTraining';
import TrainingList from './LMS_View/LMS_COURSE_MANAGEMENT/TrainingList';
import AddLearningTrack from './LMS_View/LMS_COURSE_MANAGEMENT/AddLearningTrack';
import LearningTrackList from './LMS_View/LMS_COURSE_MANAGEMENT/LearningTrackList';
import CourseDetails from './LMS_View/LMS_COURSE_MANAGEMENT/CourseDetails';
import ArchiveCourseList from './LMS_View/LMS_COURSE_MANAGEMENT/ArchiveCourseList';
import AddQuestion from './LMS_View/LMS_QUIZ_MANAGMENT/AddQuestion';
import QuestionList from './LMS_View/LMS_QUIZ_MANAGMENT/QuestionList';
import CreateQuiz from './LMS_View/LMS_QUIZ_MANAGMENT/CreateQuiz';
import QuizList from './LMS_View/LMS_QUIZ_MANAGMENT/QuizList';
import FileLibrary from './LMS_View/LMS_ FILE_LIBRARY/FileLibrary';
import UserReport from './LMS_View/LMS_REPORTS/UserReport';
import CourseReport from './LMS_View/LMS_REPORTS/CourseReport';
import GroupReport from './LMS_View/LMS_REPORTS/GroupReport';
import DepartmentReport from './LMS_View/LMS_REPORTS/DepartmentReport';
import FileUpload from './LMS_View/LMS_ FILE_LIBRARY/FileUpload';
import EditTraining from './LMS_View/LMS_COURSE_MANAGEMENT/EditTraining';
import TrainingDetails from './LMS_View/LMS_COURSE_MANAGEMENT/TrainingDetails';
import CourseQuiz from './LMS_View/LMS_COURSE_MANAGEMENT/CourseQuiz';
import MessageList from './LMS_View/LMS_MESSAGES/MessageList';
import SubmitQuiz from './LMS_View/LMS_COURSE_MANAGEMENT/SubmitQuiz';
import LearnerCourseList from './LMS_View/LMS_COURSE_MANAGEMENT/LearnerCourseList';
import LearnerCourseDetails from './LMS_View/LMS_COURSE_MANAGEMENT/LearnerCourseDetails';
import FeedbackList from './LMS_View/LMS_FEEDBACK/FeedbackList';
import LearnerDashboard from './LMS_View/LMS_DASHBOARD/LearnerDashboard';
import CertificateList from './LMS_View/LMS_CERTIFICATE/CertificateList';
import AddExternalTraining from './LMS_View/LMS_COURSE_MANAGEMENT/AddExternalTraining';
import ExternalTrainingList from './LMS_View/LMS_COURSE_MANAGEMENT/ExternalTrainingList';
import EnrollList from './LMS_View/LMS_COURSE_MANAGEMENT/EnrollList';
import LeaderBoard from './LMS_View/LMS_LEADERBOARD/LeaderBoard';
import ReportForm from './LMS_View/LMS_REPORTS/ReportForm';
import Notification from './LMS_View/LMS_NOTIFICATION/Notification';
import AddTemplate from './LMS_View/LMS_CERTIFICATE/AddTemplate';
import TemplateList from './LMS_View/LMS_CERTIFICATE/TemplateList';
import UpdateTemplate from './LMS_View/LMS_CERTIFICATE/UpdateTemplate';
import { steps } from './LMS_View/LMS_TOUR/steps';
import { TourProvider } from '@reactour/tour';
import AuditTrail from './LMS_View/LMS_REPORTS/AuditTrail';
import AuditReport from './LMS_View/LMS_REPORTS/AuditReport';
import axios from 'axios';
import AttendanceList from './LMS_View/LMS_HR/AttendanceList';
import SalaryList from './LMS_View/LMS_HR/SalaryList';
import DisableDevtool from 'disable-devtool';

function App() {

  const navigate = useNavigate()
  const [sidebar, setSidebar] = useState(true)

  const timeoutRef = useRef(null);

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(handleSessionTimeout, 1800000); // 30 minutes
  };

  const handleSessionTimeout = () => {
    // console.log('Session timed out due to inactivity.');
    localStorage.clear();
    navigate('/login');
  }

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];
    const handleUserActivity = () => resetTimeout();

    events.forEach((event) => window.addEventListener(event, handleUserActivity));

    // Initialize the timeout on component mount
    resetTimeout();

    // Cleanup event listeners on component unmount
    return () => {
      events.forEach((event) => window.removeEventListener(event, handleUserActivity));
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [])

  useEffect(() => {
    const responseInterceptor = axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response && error.response.status === 401) {
          // console.log("Unauthorized! Logging out...");
          localStorage.clear();
          navigate("/login");
        }
        return Promise.reject(error);
      }
    );

    // Cleanup interceptors when component unmounts
    return () => {
      // axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  useEffect(() => {
    // DisableDevtool()
  }, [])

  return (
    <div className="App">

      <TourProvider
        steps={steps.map((step) => ({
          ...step,
          content: ({ setIsOpen }) => (
            <>
              <div className='text-end'>
                <button style={{
                  position: "relative",
                  bottom: "15px",
                  left: "24px",
                  padding: "4px 15px",
                  backgroundColor: "#007BFF",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                }} onClick={() => setIsOpen(false)}>Skip</button>
              </div>
              <p>{step.content}</p>
            </>

          )
        }))}
        badgeContent={({ totalSteps, currentStep }) => `${currentStep + 1}/${totalSteps}`}
      >
        <Routes>
          <Route path='/login' element={<LOGIN setSidebar={setSidebar} />} />

          {/* ADMIN-INSTRUCTOR-LEARNER ROUTES  */}

          <Route element={<ProtectedRoutes allowedRoles={['Admin', 'Instructor', 'Learner']} sidebar={sidebar} setSidebar={setSidebar} />}  >
            <Route path='/' element={<Navigate replace to='/dashboard' />} />
            <Route path='/group_list' element={<GroupList />} />
            <Route path='/training_list' element={<TrainingList />} />
            <Route path='/training_details' element={<TrainingDetails />} />
            <Route path='/messages' element={<MessageList />} />
            <Route path='/external_training_list' element={<ExternalTrainingList />} />
            <Route path='/leader_board' element={<LeaderBoard />} />
            <Route path='/notification' element={<Notification />} />
            <Route path='/user_report' element={<UserReport />} />
            <Route path='/attendance_list' element={<AttendanceList />} />
            <Route path='/salary_list' element={<SalaryList />} />

          </Route>

          {/* ADMIN-INSTRUCTOR ROUTES */}

          <Route element={<ProtectedRoutes allowedRoles={['Admin', 'Instructor']} sidebar={sidebar} setSidebar={setSidebar} />}  >

            <Route path='/dashboard' element={<Dashboard />} />
            <Route path='/user_list' element={<UserList />} />
            <Route path='/course_list' element={<CourseList />} />
            <Route path='/course_details' element={<CourseDetails setSidebar={setSidebar} />} />
            <Route path='/add_training' element={<AddTraining />} />
            <Route path='/edit_training' element={<EditTraining />} />
            <Route path='/add_learning_track' element={<AddLearningTrack />} />
            <Route path='/learning_track' element={<LearningTrackList />} />

            <Route path='/add_question' element={<AddQuestion />} />
            <Route path='/question_list' element={<QuestionList />} />
            <Route path='/create_quiz' element={<CreateQuiz />} />
            <Route path='/quiz_list' element={<QuizList />} />

            <Route path='/library' element={<FileLibrary />} />
            <Route path='/upload_files' element={<FileUpload />} />

            {/* <Route path='/course_report' element={<CourseReport />} />
          <Route path='/group_report' element={<GroupReport />} />
          <Route path='/department_report' element={<DepartmentReport />} /> */}
            <Route path='/report' element={<ReportForm />} />
            {/* <Route path='/audit-trail' element={<AuditTrail />} /> */}
            <Route path='/audit-report' element={<AuditReport />} />

            <Route path='/feedback' element={<FeedbackList />} />
          </Route>

          {/* ADMIN ROUTES */}

          <Route element={<ProtectedRoutes allowedRoles={['Admin']} sidebar={sidebar} setSidebar={setSidebar} />}  >

            <Route path='/department' element={<Department />} />
            <Route path='/add_group' element={<AddGroup />} />
            <Route path='/venue' element={<Venue />} />
            <Route path='/announcement' element={<Announcement />} />
            <Route path='/poll' element={<Poll />} />
            <Route path='/quiz_marks' element={<QuizMarks />} />
            <Route path='/add_course' element={<AddCourse />} />
            <Route path='/archive_course' element={<ArchiveCourseList />} />
            <Route path='/enroll_course_list' element={<EnrollList />} />
            <Route path='/add_certificate_template' element={<AddTemplate />} />
            <Route path='/update_certificate_template' element={<UpdateTemplate />} />
            <Route path='/certificate_template_list' element={<TemplateList />} />

          </Route>

          {/* LEARNER ROUTES */}

          <Route element={<ProtectedRoutes allowedRoles={['Learner']} sidebar={sidebar} setSidebar={setSidebar} />}  >

            <Route path='/learner-dashboard' element={<LearnerDashboard />} />
            <Route path='/learner_course_list' element={<LearnerCourseList />} />
            <Route path='/learner_course_details' element={<LearnerCourseDetails setSidebar={setSidebar} />} />
            <Route path='/course_quiz' element={<CourseQuiz setSidebar={setSidebar} />} />
            <Route path='/submit_quiz' element={<SubmitQuiz />} />
            <Route path='/certificates' element={<CertificateList />} />
            <Route path='/add_external_training' element={<AddExternalTraining />} />

          </Route>
        </Routes>
      </TourProvider>

    </div>
  );
}

export default App;
